module.exports = __webpack_public_path__ + "media/heyphil-video.480eb90f.mp4";